import React, { useState } from "react";
import {
  RedButton,
  ModalComponent,
  FlexContainer,
  CustomLabel,
} from "@mindmemobile/mm-shared-global";
import { CategoriesModel } from "../../../shared/models";

type DeleteCategoryPopupProps = {
  categories: CategoriesModel[];
  category: CategoriesModel;
  onClose: (refresh: boolean) => void;
  onDelete: (
    category: CategoriesModel,
    copyCategoryId: string | undefined
  ) => void;
};

const DeleteCategoryPopup: React.FC<DeleteCategoryPopupProps> = ({
  category,
  onClose,
  onDelete,
}) => {
  const [isProcessing, setIsProcessing] = useState(false);
  // const [copy, setCopy] = useState(false);
  // const [copyCategory, setCopyCategory] = useState<CategoriesModel | null>(null);
  // const [isCopyError, setIsCopyError] = useState(false);

  const handleDelete = () => {
    // if (copy && !copyCategory) {
    //     // setIsCopyError(true);
    //     return;
    // }
    setIsProcessing(true);
    onDelete(category, undefined);
    // onDelete(category, copy ? copyCategory?.id : undefined);
    setIsProcessing(false);
  };

  // const getOptions = (): IOption[] => {
  //     return categories
  //         .filter((cat) => cat.id !== category.id)
  //         .map((cat) => ({
  //             label: cat.name,
  //             value: cat.id,
  //         }));
  // };

  return (
    <ModalComponent
      title="Delete Category"
      onClose={() => onClose(false)}
      showFooter
      redHeader={true}
      blueHeader={false}
      wrapperWidth="400px"
      footerContent={
        <FlexContainer justifyContent="center" spacing={15}>
          <RedButton onClick={() => onClose(false)}>Do Not Delete</RedButton>
          <RedButton onClick={handleDelete} disabled={isProcessing} primary>
            Delete
          </RedButton>
        </FlexContainer>
      }
    >
      <FlexContainer
        padding="50px"
        justifyContent="center"
        alignItems="center"
        fxLayout="column"
        spacing={20}
      >
        <CustomLabel>
          Do you want to{" "}
          <span style={{ color: "#FF0000", fontWeight: "bold" }}>delete</span>{" "}
          this Category?
        </CustomLabel>
        <FlexContainer
          fxLayout="column"
          spacing={10}
          justifyContent="center"
          alignItems="center"
        >
          <CustomLabel fontWeight={"bold"} color="#555555" fontSize={"20px"}>
            {category.name}
          </CustomLabel>
          <CustomLabel>Used in {category.usedInItems} items</CustomLabel>
        </FlexContainer>
        {/* <Input
                  type="checkbox"
                  value={copy}
                  onChange={(e) => setCopy(e.target.checked)}
                  label={'Copy to another Category?'}
                  disabled={false}
              />
              {copy && (
                  <SingleSelect
                      hasError={isCopyError}
                      selectedKey={copyCategory?.id || ''}
                      nameKeys={['label']}
                      valueKeys={['value']}
                      options={[getOptions()]}
                      onChange={(option: IOption) => {
                          setCopyCategory(categories.find((cat) => cat.id === option.value) || null);
                      }}
                  />
              )} */}
      </FlexContainer>
    </ModalComponent>
  );
};

export default DeleteCategoryPopup;
